"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlH6TagImporter = exports.HtmlH5TagImporter = exports.HtmlH4TagImporter = exports.HtmlH3TagImporter = exports.HtmlH2TagImporter = exports.HtmlH1TagImporter = exports.HtmlPTagImporter = void 0;
var tslib_1 = require("tslib");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var dom_1 = require("@devexpress/utils/lib/utils/dom");
var string_1 = require("@devexpress/utils/lib/utils/string");
var base_1 = require("./base");
var HtmlPTagImporter = (function (_super) {
    tslib_1.__extends(HtmlPTagImporter, _super);
    function HtmlPTagImporter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listInfo = null;
        _this.importChilds = false;
        return _this;
    }
    HtmlPTagImporter.prototype.elementTag = function () {
        return "P";
    };
    HtmlPTagImporter.prototype.importBefore = function () {
        var emptyParagraphMatches = this.element.outerHTML.match(/^<([^\s >]+)(\s[^>]*)?>&nbsp;<\/\1>/gi);
        if (!(emptyParagraphMatches && emptyParagraphMatches.length)) {
            if (string_1.StringUtils.trim(dom_1.DomUtils.getInnerText(this.element)))
                this.listInfo = this.importer.paragraphListpropertiesUtils.import(this.element, new fixed_1.FixedInterval(this.importer.currPosition, 0));
            this.importChilds = true;
        }
    };
    HtmlPTagImporter.prototype.isImportChilds = function () {
        return this.importChilds;
    };
    HtmlPTagImporter.prototype.importAfter = function () {
        this.importer.addParagraphRun(this.listInfo, this.element);
    };
    return HtmlPTagImporter;
}(base_1.HtmlTagImporterBase));
exports.HtmlPTagImporter = HtmlPTagImporter;
var HtmlH1TagImporter = (function (_super) {
    tslib_1.__extends(HtmlH1TagImporter, _super);
    function HtmlH1TagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlH1TagImporter.prototype.elementTag = function () {
        return "H1";
    };
    return HtmlH1TagImporter;
}(HtmlPTagImporter));
exports.HtmlH1TagImporter = HtmlH1TagImporter;
var HtmlH2TagImporter = (function (_super) {
    tslib_1.__extends(HtmlH2TagImporter, _super);
    function HtmlH2TagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlH2TagImporter.prototype.elementTag = function () {
        return "H2";
    };
    return HtmlH2TagImporter;
}(HtmlPTagImporter));
exports.HtmlH2TagImporter = HtmlH2TagImporter;
var HtmlH3TagImporter = (function (_super) {
    tslib_1.__extends(HtmlH3TagImporter, _super);
    function HtmlH3TagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlH3TagImporter.prototype.elementTag = function () {
        return "H3";
    };
    return HtmlH3TagImporter;
}(HtmlPTagImporter));
exports.HtmlH3TagImporter = HtmlH3TagImporter;
var HtmlH4TagImporter = (function (_super) {
    tslib_1.__extends(HtmlH4TagImporter, _super);
    function HtmlH4TagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlH4TagImporter.prototype.elementTag = function () {
        return "H4";
    };
    return HtmlH4TagImporter;
}(HtmlPTagImporter));
exports.HtmlH4TagImporter = HtmlH4TagImporter;
var HtmlH5TagImporter = (function (_super) {
    tslib_1.__extends(HtmlH5TagImporter, _super);
    function HtmlH5TagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlH5TagImporter.prototype.elementTag = function () {
        return "H5";
    };
    return HtmlH5TagImporter;
}(HtmlPTagImporter));
exports.HtmlH5TagImporter = HtmlH5TagImporter;
var HtmlH6TagImporter = (function (_super) {
    tslib_1.__extends(HtmlH6TagImporter, _super);
    function HtmlH6TagImporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlH6TagImporter.prototype.elementTag = function () {
        return "H6";
    };
    return HtmlH6TagImporter;
}(HtmlPTagImporter));
exports.HtmlH6TagImporter = HtmlH6TagImporter;
